// extracted by mini-css-extract-plugin
export var bulletedList = "styles-module--bulletedList--2a-C8";
export var careNeedsLink = "styles-module--careNeedsLink--76FHf";
export var careTypeSpecificLinks = "styles-module--careTypeSpecificLinks--Royyl";
export var listItem = "styles-module--listItem--qu3bO";
export var mainContent = "styles-module--mainContent--1XsNS";